export default __webpack_public_path__ + "static/media/fooody.fd356a3d.png";